import get from 'lodash/get';
import union from 'lodash/union';
import { optionTypes, sections } from '../constants';

export const unitePropertyTypesBySections = (sortedPropertyTypes, option = optionTypes.buy) => {
  const sectionNames = Object.keys(sections);

  const types = sectionNames.map(item => {
    const sectionValue = get(sections, `${item}.value`);
    return get(sortedPropertyTypes, `${sectionValue}.${option}`);
  });

  return union(...types);
};

export const unitePropertyTypesByOptions = (sortedPropertyTypes, section = sections.homes.value) => {
  const options = Object.keys(optionTypes);
  const types = options.map(option => get(sortedPropertyTypes, `${section}.${option}`));

  return union(...types);
};
